import { findNearestAirport } from "airport-data-js";
import { getCurrentLocation, getLocationPermission } from "./locationService";
import airportData from "airport-iata-codes";
import cityCodes from "./cityCodes.json";
import { COUNTRY_INFO } from "../../constans/countries/countries";
import { useDispatch } from "react-redux";

const TRIP_URL = "https://www.trip.com/";

const CAPITAL_FIXES = {
    "Kralendijk, Oranjestad, The Bottom": "Oranjestad",
};

export const getRoute = async (capital, passport) => {
    
    const passportCountry = COUNTRY_INFO[passport];
    const passportCapital = passportCountry?.capital;
    const destination = CAPITAL_FIXES[capital] || capital;
    const destinationCode = cityCodes[destination];
    const location = await getCurrentLocation();
    let depatureCityCode;

    if (location) {
        const airport = await findNearestAirport(
            location.latitude,
            location.longitude,
            {
                type: "large_airport",
                has_scheduled_service: true,
            }
        );

        if (airport?.iata) {
            const data = airportData(airport.iata);
            depatureCityCode = data[0]?.city_code;
        }
    }

    if (!location) {
        depatureCityCode = cityCodes[passportCapital];
    }

    const route =
        `${encodeURIComponent(depatureCityCode)}` +
        `-to-${encodeURIComponent(destination)}`;

    return (
        `https://www.trip.com/flights/` +
        `${route}` +
        `/tickets-${depatureCityCode}-${destinationCode}` +
        `?flighttype=S` +
        `&dcity=${depatureCityCode}` +
        `&acity=${destinationCode}` +
        `&Allianceid=8017136` +
        `&SID=303143737` +
        `&trip_sub1=country_counter_app` +
        `&trip_sub3=D19910550`
    );
};